import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { clsx } from 'clsx';

export const DeadlineFilters = ({ activeFilter, onFilterChange, stats }) => {
  const filters = [
    { 
      id: 'all', 
      label: 'All Deadlines', 
      count: stats.total,
      icon: FiIcons.FiList,
      color: 'slate'
    },
    { 
      id: 'overdue', 
      label: 'Overdue', 
      count: stats.overdue,
      icon: FiIcons.FiAlertCircle,
      color: 'red'
    },
    { 
      id: 'critical', 
      label: 'Critical (≤2 days)', 
      count: stats.critical,
      icon: FiIcons.FiAlertTriangle,
      color: 'orange'
    },
    { 
      id: 'warning', 
      label: 'Warning (3-5 days)', 
      count: stats.warning,
      icon: FiIcons.FiClock,
      color: 'amber'
    },
    { 
      id: 'normal', 
      label: 'On Track', 
      count: stats.normal,
      icon: FiIcons.FiCheckCircle,
      color: 'green'
    }
  ];

  const colorClasses = {
    slate: {
      active: 'bg-slate-100 border-slate-300 text-slate-900',
      inactive: 'bg-white border-slate-200 text-slate-600 hover:border-slate-300'
    },
    red: {
      active: 'bg-red-100 border-red-300 text-red-900',
      inactive: 'bg-white border-slate-200 text-slate-600 hover:border-red-200'
    },
    orange: {
      active: 'bg-orange-100 border-orange-300 text-orange-900',
      inactive: 'bg-white border-slate-200 text-slate-600 hover:border-orange-200'
    },
    amber: {
      active: 'bg-amber-100 border-amber-300 text-amber-900',
      inactive: 'bg-white border-slate-200 text-slate-600 hover:border-amber-200'
    },
    green: {
      active: 'bg-green-100 border-green-300 text-green-900',
      inactive: 'bg-white border-slate-200 text-slate-600 hover:border-green-200'
    }
  };

  return (
    <div className="flex flex-wrap gap-3">
      {filters.map(filter => {
        const isActive = activeFilter === filter.id;
        const classes = colorClasses[filter.color];
        
        return (
          <button
            key={filter.id}
            onClick={() => onFilterChange(filter.id)}
            className={clsx(
              "px-4 py-2 rounded-lg border font-medium text-sm transition-all flex items-center gap-2",
              isActive ? classes.active : classes.inactive
            )}
          >
            <SafeIcon icon={filter.icon} />
            <span>{filter.label}</span>
            <span className={clsx(
              "ml-1 px-2 py-0.5 rounded-full text-xs font-bold",
              isActive 
                ? "bg-white/50" 
                : "bg-slate-100"
            )}>
              {filter.count}
            </span>
          </button>
        );
      })}
    </div>
  );
};